<template>
	<b-container fluid>
		<b-row>
			<b-col cols="10" offset="1">
				<b-img src="images/green-valley-banner.jpg" class="w-100"></b-img>
				<b-navbar toggleable="md" variant="dark" type="dark" sticky>
					<b-navbar-nav fill class="flex-grow-1">
                        <b-nav-item>
							<b-button block pill variant="success" class="flex-grow-1" to="download">Download</b-button>
						</b-nav-item>
                        <b-nav-item>
							<b-button block pill variant="info" class="flex-grow-1" to="user-manual">User Manual</b-button>
						</b-nav-item>
                        <b-nav-item>
							<b-button block pill variant="info" class="flex-grow-1" to="character-importer">Character Importer SDK</b-button>
						</b-nav-item>
                        <b-nav-item>
							<b-button block pill variant="info" class="flex-grow-1" to="interaction-studio">Interaction Studio</b-button>
						</b-nav-item>
                        <b-nav-item href="https://www.patreon.com/softscale">
							<b-button block pill variant="light" class="flex-grow-1">Patreon</b-button>
						</b-nav-item>
                        <b-nav-item href="https://subscribestar.adult/softscale">
							<b-button block pill variant="light" class="flex-grow-1">SubscribeStar</b-button>
						</b-nav-item>
					</b-navbar-nav>
				</b-navbar>

				<h3 class="mt-4 mb-4 text-center" style="line-height:1.5em">
                    FarmD is a furry sex sandbox game, focused on engaging in lewd acts with your four-legged friend.<br />
					The game is still early in development, and will be expanded to support additional species for the player and partner, more toys and activities, anthro partners, and more!<br />
					The game supports both VR and desktop (non-VR) play styles, with VR being the focus but most content is accessible in either mode.<br />
					<span  class="font-weight-bold">You must be 18 years of age or older to play this game.</span>
				</h3>
                
                <b-carousel id="carousel-1"
                            :interval="4000"
							class="mt-5"
                            controls
                            indicators
                            background="#ababab"
                            img-width="1024"
                            img-height="480"
                            style="text-shadow: 1px 1px 2px #333;">
                    <b-carousel-slide img-src="images/carousel/1_sleeping.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="images/carousel/3_cum.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="images/carousel/10_anthro_anthro.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="images/carousel/4_kiss.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="images/carousel/9_vr_pet_partner.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="images/carousel/5_suck.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="images/carousel/7_vr_fingering.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="images/carousel/2_skin_editor.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="images/carousel/8_vr_character_menu.jpg"></b-carousel-slide>
                    <b-carousel-slide img-src="images/carousel/6_interaction_studio.jpg"></b-carousel-slide>
                </b-carousel>

				<h3 class="mt-5">Features:</h3>
                <ul class="h4" style="line-height:1.5em">
                    <li>Engage in a variety of sex positions, giving or receiving.</li>
                    <li>Relax with some petting, mawplay, or cuddling in bed.</li>
                    <li>Customize body types, genitals, patterns and colors for yourself or your partner.</li>
                    <li>Supports synchronization with various bluetooth-enabled toys like strokers or buttplugs, for real haptic feedback to the action.</li>
                    <li>Full-body VR avatars, with tracking support for waist, feet, and fingers.</li>
                    <li>Physically simulated fluids.</li>
                    <li>Frequent updates! Become a supporter on Patreon or Subscribestar for access to the latest content as it's developed, or follow along with the public builds - all content is released periodically in these free builds.</li>
                </ul>

				<b-button variant="success" size="lg" class="mt-4 mb-5" to="download">Download</b-button>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
export default {
	name: 'Home',
	computed: {
	},
	created() {
	},
	methods: {
	},
}
</script>

<style scoped>
</style>
